import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ROUTE_MAP } from 'consts/url';

import './apartmentTypeSelector.scss';
import { PageFilterCard } from 'components/FilterCard';

const APARTMENT_SELECT = [
  {
    label: 'Căn hộ 1PN',
    url: `/${ROUTE_MAP.interior.id}/1pn/tong-quan`,
    id: `1pn`,
  },
  {
    label: 'Căn hộ 1PN+',
    url: `/${ROUTE_MAP.interior.id}/1pn-plus/tong-quan`,
    id: `1pn-plus`,
  },
  {
    label: 'Căn hộ 2PN',
    url: `/${ROUTE_MAP.interior.id}/2pn/tong-quan`,
    id: `2pn`,
  },
  {
    label: 'Căn hộ 3PN',
    url: `/${ROUTE_MAP.interior.id}/3pn/tong-quan`,
    id: `3pn`,
  },
];

const ApartmentTypeSelector = () => {
  const isDesktop = window.innerWidth > 1180;

  if (!isDesktop) {
    return (
      <div className="selector-mobile">
        <Content />
      </div>
    );
  }

  return (
    <PageFilterCard className="apartment-type-selector">
      <Content />
    </PageFilterCard>
  );
};

const Content = () => {
  const history = useHistory();
  const { pathname } = history.location;

  return (
    <div className="apartment-selector-content">
      {APARTMENT_SELECT.map(({ label, url, id }) => {
        const isActive = pathname.split('/')[2] === id;

        return (
          <button
            key={url}
            onClick={() => history.push(`${url}`)}
            className={`apartment-option ${isActive ? 'active' : ''}`}
          >
            <span className="apartment-option-label">{label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ApartmentTypeSelector;
